<template>
  <CrudList
    form-input-placeholder="Zoek blokken..."
    title-empty-placeholder="Er zijn geen pagina's"

    label="Titel blokkeren"
    edit-title="Blok bewerken"
    add-title="Blok toevoegen"
    type="block"

    add-success-message="Een nieuw blok is succesvol toegevoegd!"
    edit-success-message="Blok succesvol bewerkt!"
    
    v-bind="$attrs"
  />
</template>

<script>

import CrudList from "./CrudList.vue"

export default {
  components: {
    CrudList,
  },
}

</script>
